import React, { Component } from 'react';
import {NavLink,Link} from 'react-router-dom';



export class Header extends Component {

    render(){
        return(
        <>
        <header>
              <nav className="navbar navbar-expand-lg navbar-dark fixed-top bg-dark">
              <Link className="navbar-brand" to="/">BIEK</Link>
              <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarCollapse">
                <ul className="navbar-nav mr-auto">
                  <li className="nav-item">
                    <NavLink className="nav-link" activeClassName="active" to="/">Home </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" activeClassName="active" to="/result">Current Resuts</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" activeClassName="active" to="/about">About us</NavLink>
                  </li>
                  <li className="nav-item" activeClassName="active">
                    <NavLink className="nav-link " to="/faqs">FAQ</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" activeClassName="active" to="/contact">Contact us</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" activeClassName="active" to="/circular-news">Circular News</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" activeClassName="active" to="/activities">Activites</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" activeClassName="active" to="/date-sheet">Date Sheets</NavLink>
                  </li>
                </ul>
              </div>
            </nav>
        </header>
            </>
        );
    }
} 